import { IPaymentMethod } from "@/interfaces"
import { defineStore } from "pinia"
import { ref } from "vue"

const STORAGE_KEY = "PAYMENT_METHOD_STORAGE"
const STORE_KEY = "PAYMENT_METHOD_STORE"

const getFromLocalStorage = (): IPaymentMethod | null => {
    const item = localStorage.getItem(STORAGE_KEY)
    if (!item) return null
    return JSON.parse(item) as IPaymentMethod
}
export const usePaymentMethodStore = defineStore(STORE_KEY, () => {
    const currentPaymentMethod = ref<IPaymentMethod | null>(getFromLocalStorage())

    const savePaymentMethod = (pm: IPaymentMethod) => {
        currentPaymentMethod.value = pm
        updateLocalStorage()
    }
    const removePaymentMethod = () => {
        currentPaymentMethod.value = null
        clearLocalStorage()
    }

    function updateLocalStorage() {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(currentPaymentMethod.value))
    }
    function clearLocalStorage() {
        localStorage.removeItem(STORAGE_KEY)
    }

    return { currentPaymentMethod, savePaymentMethod, removePaymentMethod }
})